<template>
  <div>
    <v-main>
      <router-view></router-view>
    </v-main>
  </div>
</template>

<script>
export default {
  name: 'ReportRootPage',
}
</script>
